import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '../../core/guard/auth.guard';

export const dashboardRoutes =
{
  path: '', canActivateChild: [AuthGuard], children: [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: 'dashboard', component: DashboardComponent, pathMatch: 'full' },
  ]
}
